import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_ds_material_components_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { material_id: number, packaging_id: number, full_text_search?: string }): 
  Promise<{ result: { Id?: number, ComponentMaterialId?: number, ComponentPackagedAmount?: number, ComponentPackagedId?: number, MaterialId?: number, PackagingId?: number, ComponentMaterial?: { LookupCode?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.material_id)) {
      missingRequiredInParams.push('\'material_id\'');
    }
    if (isNil(inParams.packaging_id)) {
      missingRequiredInParams.push('\'packaging_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_material_components_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { material_id: number, packaging_id: number, full_text_search?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ComponentMaterialId?: number, ComponentPackagedAmount?: number, ComponentPackagedId?: number, MaterialId?: number, PackagingId?: number, ComponentMaterial?: { LookupCode?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.material_id)) {
      missingRequiredInParams.push('\'material_id\'');
    }
    if (isNil(inParams.packaging_id)) {
      missingRequiredInParams.push('\'packaging_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_material_components_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { material_id: number, packaging_id: number, full_text_search?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, ComponentMaterialId?: number, ComponentPackagedAmount?: number, ComponentPackagedId?: number, MaterialId?: number, PackagingId?: number, ComponentMaterial?: { LookupCode?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.material_id)) {
      missingRequiredInParams.push('\'material_id\'');
    }
    if (isNil(inParams.packaging_id)) {
      missingRequiredInParams.push('\'packaging_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_material_components_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      material_id: number, packaging_id: number, full_text_search?: string    }) {
        if(isNil(inParams.material_id)) {
          return true; 
        }
        if(isNil(inParams.packaging_id)) {
          return true; 
        }
      return false;
    }
}
